import axios from 'axios';
import VueRecaptcha from 'vue-recaptcha';
import { required, email, minLength, maxLength } from 'vuelidate/lib/validators';
import Multiselect from 'vue-multiselect';

const STATE = {
	LOADING: 'LOADING',
	ERROR: 'ERROR',
	SUCCESS: 'SUCCESS',
	IDLE: 'IDLE'
};

const DEFAULT_MODEL = {
	name: '',
	email: '',
	company: '',
	phone: '',
	message: '',
	contactMode: '',
	gdpr: false
};

export default {
	name: 'frm01-form',
	data() {
		return {
			model: {...DEFAULT_MODEL},

			state: STATE.IDLE,
			STATE
		};
	},
	components: {
		VueRecaptcha,
		multiselect: Multiselect
	},
	validations: {
		model: {
			name: {
				required,
				maxLength: maxLength(50)
			},
			email: {
				required,
				email,
				maxLength: maxLength(50)
			},
			company: {
				maxLength: maxLength(50)
			},
			phone: {
				maxLength: maxLength(50)
			},
			message: {
				maxLength: maxLength(500)
			},
			gdpr: {
				required: (value) => value == true
			}
		}
	},
	methods: {
		validateRecaptcha() {
			this.$v.$touch();
			if (this.$v.$invalid) return;

			this.state = STATE.LOADING;
			this.$refs.recaptcha.execute();
		},

		onRecaptchaSuccess(token) {
			axios.post('/apps/form', this.model, {
				headers: {
					'X-Recaptcha-Token': token
				}
			})
				.then(() => {
					this.state = STATE.SUCCESS;
					document.querySelector('html').style.overflow = 'hidden'
					this.model = {...DEFAULT_MODEL};
					this.$v.$reset();
				})
				.catch(_err => {
					console.error('Nem sikerült lementeni a formot.', _err);
					this.state = STATE.ERROR;
				});
		},

		onRecaptchaFailed() {
			console.error('Nem sikerült a recaptcha validáció.');
			this.state = STATE.ERROR;
		},

		hasError(field, errorType) {
			return this.$v.model[field].$dirty && !this.$v.model[field][errorType];
		}
	}
};



// WEBPACK FOOTER //
// ../source/modules/FRM01-form/FRM01-form.js